import { render } from "./sales-dashboard.vue?vue&type=template&id=deab49c8&scoped=true"
import script from "./sales-dashboard.vue?vue&type=script&lang=js"
export * from "./sales-dashboard.vue?vue&type=script&lang=js"

import "./sales-dashboard.vue?vue&type=style&index=0&id=deab49c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deab49c8"]])

export default __exports__